﻿import { ConfirmCVLRequest } from './cashvaluerequest/ConfirmCVLRequest';
import { SentConfirmationForCVL } from './cashvaluerequest/SentConfirmationForCVL';
import { ConfirmCoOwnerCaptureEmail } from './beneficiary/ConfirmCoOwnerCaptureEmail';
import { ConfirmOwnerCaptureEmail } from './beneficiary/ConfirmOwnerCaptureEmail';
import { ConfirmBeneSent } from './beneficiary/ConfirmBeneSent';
import { HowManyBene } from './beneficiary/HowManyBene';
import { SpouseQuestionCaptureEmail } from './beneficiary/SpouseQuestionCaptureEmail';
import { ConfirmPrimaryOwner } from './OwnershipChange/ConfirmPrimaryOwner';
import { HowToReceive } from './OwnershipChange/HowToReceive';
import { ConfirmOwnershipChange } from './OwnershipChange/ConfirmOwnershipChange';
import { DeliveryMethod } from './claimForm/DeliveryMethod';
import { PolicyCheck } from './claimForm/PolicyCheck';
import { Participant } from './claimForm/Participant';
import { EndCall } from './claimForm/EndCall';

//Update imports and switch case for all wizard steps in system.
const PhoneStepRenderer = ({
  step,
  referenceID,
  currentIndex,
  skipHandler,
  lastIndex,
  completedHandler,
  previousHandler,
  nextHandler,
  errorHandler,
  showHiddenHandler,
  hideShownHandler,
  clickOnDocu,
  setClickOnDocu,
  insuredFullName,
}) => {
  const props = {
    step,
    currentIndex,
    referenceID,
    lastIndex,
    skipHandler,
    completedHandler,
    previousHandler,
    nextHandler,
    errorHandler,
    showHiddenHandler,
    hideShownHandler,
    clickOnDocu,
    setClickOnDocu,
    insuredFullName,
  };

  let Comp = componentMap['Default'];
  if (componentMap[step.component]) {
    Comp = componentMap[step.component];
  }

  return <Comp {...props} />;
};

const componentMap = {
  ConfirmCVLRequest: ConfirmCVLRequest,
  SentConfirmationForCVL: SentConfirmationForCVL,
  ConfirmBeneSent: ConfirmBeneSent,
  HowManyBene: HowManyBene,
  SpouseQuestionCaptureEmail: SpouseQuestionCaptureEmail,
  ConfirmOwnerCaptureEmail: ConfirmOwnerCaptureEmail,
  ConfirmCoOwnerCaptureEmail: ConfirmCoOwnerCaptureEmail,
  ConfirmPrimaryOwner: ConfirmPrimaryOwner,
  HowToReceive: HowToReceive,
  ConfirmOwnershipChange: ConfirmOwnershipChange,
  DeliveryMethod: DeliveryMethod,
  PolicyCheck: PolicyCheck,
  Participant: Participant,
  EndCall: EndCall,
  Default: <div>Step Not Found</div>,
};

export default PhoneStepRenderer;
